import { Button } from '@mui/material';

import './FormButton.scss';

interface FormButtonProps {
    disabled?: boolean | undefined;
    type?: 'button' | 'submit' | 'reset';
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

const FormButton = (
    props: React.PropsWithChildren<FormButtonProps>,
): JSX.Element => {
    return (
        <Button variant='contained' {...props}>
            {props.children}
        </Button>
    );
};

export default FormButton;
